export const VIDEO_MAX_LENGTH = 60;
export const VIDEO_MIN_LENGTH = 15;

// Flush recorded data once per second instead of buffering the whole clip into
// a single segment. iOS Safari's MediaRecorder freezes the video track (audio
// keeps going) on long single-segment recordings; periodic timeslices keep the
// muxer flushing so the full clip stays intact. Must be paired with chunk
// accumulation in VideoRecord (ondataavailable fires repeatedly with a slice).
export const RECORDER_TIMESLICE_MS = 1000;

// ~0.6 Mbps. A quality bump from the old ~0.2 Mbps, which produced very blocky
// 30fps full-width video. Kept under 1 Mbps so a max-length (60s) recording
// stays only a few MB to upload (~0.6 Mbps × 60s ≈ 4.5 MB + audio).
// NOTE: this is a quality choice only — it does NOT fix the long-recording
// freeze; RECORDER_TIMESLICE_MS + chunk accumulation in VideoRecord do.
export const VIDEO_BITS_PER_SECOND = Math.round(0.6 * 1024 * 1024);
